export const translations = {
  fr: {
    brand: "M.SAH",
    nav: { home: "Accueil", formation: "La Formation", testimonials: "Témoignages", login: "Se connecter", member: "Espace membre", admin: "Admin", profile: "Profil", logout: "Déconnexion" },
    home: {
      overline: "Art oratoire & développement personnel",
      line1: "PRENEZ",
      line2: "LA PAROLE.",
      line3: "on vous écoute.",
      sub: "Je m'appelle M.SAH. J'aide chaque jour des milliers de personnes à parler en public avec confiance — et j'ai condensé ma méthode dans une formation complète.",
      cta: "Découvrir la formation",
      cta2: "Qui suis-je ?",
      scroll: "Défiler",
      stat1: "abonnés TikTok",
      stat2: "abonnés Facebook",
      statFollow: "Suivre",
      about: {
        overline: "Qui suis-je ?",
        title: "M.SAH,",
        titleSerif: "orateur avant tout.",
        p1: "Créateur de contenu en art oratoire et développement personnel, j'ai construit une communauté de plus de 200 000 personnes sur TikTok et Facebook autour d'une conviction simple : tout le monde peut apprendre à bien parler en public.",
        p2: "Ma mission : vous donner les techniques concrètes — mentales, vocales, physiques — pour transformer le stress en présence, et vos idées en impact.",
        social: "Retrouvez-moi sur",
      },
      mission: {
        overline: "Ma mission",
        title: "Trois convictions.",
        chapters: [
          { num: "01", title: "La parole s'apprend", text: "Personne ne naît orateur. La confiance, la voix, la structure : tout se travaille, avec la bonne méthode et de la pratique guidée." },
          { num: "02", title: "Le concret avant la théorie", text: "Chaque vidéo vous donne des exercices applicables immédiatement — devant votre miroir, vos proches, puis votre public." },
          { num: "03", title: "Votre voix compte", text: "Que vous parliez à 5 ou 500 personnes, votre message mérite d'être entendu. Je vous aide à le porter." },
        ],
      },
      formationTeaser: {
        overline: "La formation",
        title: "Gestion Performante de la Prise de Parole en Public",
        sub: "4 modules · 16 vidéos · fiches d'exercices PDF",
        cta: "Voir le programme",
      },
      testimonialTeaser: {
        overline: "Ils en parlent",
        title: "Les témoignages arrivent bientôt.",
        cta: "Voir la page témoignages",
      },
    },
    marquee: ["PRISE DE PAROLE", "CONFIANCE", "VOIX", "PRÉSENCE", "IMPACT", "CHARISME"],
    footer: {
      cta1: "Prêt à prendre",
      cta2: "la parole ?",
      button: "Accéder à la formation",
      tagline: "Art oratoire & développement personnel.",
      rights: "© 2026 M.SAH. Tous droits réservés.",
      contact: "Me contacter sur WhatsApp",
    },
    formation: {
      overline: "La formation complète",
      hook: "La méthode complète pour parler en public avec confiance, clarté et impact — même si vous partez de zéro.",
      program: "Le programme",
      modules: "modules",
      videos: "vidéos",
      module: "Module",
      buy: "Commander la formation",
      owned: "Accéder à ma formation",
      loginToBuy: "Créez votre compte ou connectez-vous pour commander",
      accessNote: "Accès à vie — activation immédiate après confirmation.",
      inc1: "Vidéos en streaming, accès à vie",
      inc2: "Fiches d'exercices PDF téléchargeables",
      inc3: "Progression suivie vidéo par vidéo",
      inc4: "Accès activé dès confirmation de votre paiement",
      orderTitle: "Commander la formation",
      orderNote: "Le paiement PayPal en ligne arrive très bientôt. En attendant, commandez directement via WhatsApp : je débloque votre accès immédiatement après confirmation du paiement (Western Union, MoneyGram, Ria ou autre).",
      orderBtn: "Commander via WhatsApp",
      whatsappMsg: "Bonjour M.SAH, je souhaite acheter la formation « Prise de Parole en Public » (109€).",
      secure: "Paiement flexible · Accès à vie · Support direct WhatsApp",
    },
    member: {
      title: "Espace membre",
      hello: "Bonjour",
      progress: "progression",
      viewedSuffix: "vues",
      module: "Module",
      selectLesson: "Sélectionnez une vidéo pour commencer.",
      noVideo: "Cette vidéo sera disponible très bientôt.",
      pdfTitle: "Fiches d'exercices pratiques (PDF)",
      pdfSub: "Téléchargez vos fiches et entraînez-vous entre les vidéos.",
      download: "Télécharger",
      downloadSheet: "Télécharger la fiche",
      pdfCardSub: "Fiche protégée — le téléchargement est réservé aux membres approuvés.",
      noSheet: "Cette fiche sera disponible très bientôt.",
      noPdf: "Les fiches PDF seront ajoutées très bientôt.",
      protected: "Vidéos protégées — lecture en streaming uniquement.",
      buyFirst: "Vous n'avez pas encore accès à la formation.",
      buyCta: "Voir la formation",
    },
    testimonials: {
      overline: "Témoignages",
      title: "Ils ont pris la parole.",
      empty: "Les premiers témoignages arrivent très bientôt.",
      emptySub: "Vous suivez la formation ? Votre avis pourra apparaître ici.",
      cta: "Découvrir la formation",
    },
    auth: {
      loginTitle: "Bon retour.", registerTitle: "Créez votre compte.",
      loginSub: "Retrouvez votre formation là où vous l'avez laissée.",
      registerSub: "Un compte, votre formation à vie.",
      name: "Nom complet", email: "Adresse email", password: "Mot de passe",
      loginBtn: "Se connecter", registerBtn: "Créer mon compte",
      toRegister: "Pas encore de compte ? Créer un compte",
      toLogin: "Déjà membre ? Se connecter",
      loading: "Un instant…",
      showPassword: "Afficher le mot de passe",
      hidePassword: "Masquer le mot de passe",
      forgotLink: "Mot de passe oublié ?",
      forgotTitle: "Mot de passe oublié.",
      forgotSub: "Entrez votre email : vous recevrez un lien pour choisir un nouveau mot de passe.",
      forgotBtn: "Envoyer le lien",
      forgotSent: "Si un compte existe avec cet email, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte mail (et les spams).",
      resetTitle: "Nouveau mot de passe",
      resetSub: "Choisissez votre nouveau mot de passe (6 caractères minimum).",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      resetBtn: "Enregistrer le mot de passe",
      resetMismatch: "Les deux mots de passe ne correspondent pas.",
      resetInvalid: "Lien invalide. Refaites une demande de réinitialisation.",
      resetSuccessTitle: "Mot de passe modifié.",
      resetSuccessSub: "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
      registeredNotice: "Compte créé ! Un email de confirmation vient de vous être envoyé — cliquez sur le lien pour activer votre compte.",
    },
    verify: {
      overline: "Confirmation d'email",
      wallTitle: "Confirmez votre email",
      wallSub: "Votre compte est créé mais pas encore activé. Cliquez sur le lien reçu par email (valable 24h) pour accéder à vos contenus.",
      wallResend: "Renvoyer l'email de confirmation",
      wallResent: "Email renvoyé ! Vérifiez votre boîte (et les spams).",
      wallSpam: "Pensez à vérifier vos spams. Le lien expire après 24h — un nouveau lien sera généré à chaque renvoi.",
      successTitle: "Email confirmé !",
      successSub: "Votre compte est maintenant actif. Vous pouvez accéder à tous vos contenus.",
      goMember: "Accéder à mon espace",
      errorTitle: "Lien invalide",
      errorSub: "Le lien a peut-être expiré (24h). Connectez-vous pour recevoir un nouveau lien automatiquement.",
      invalid: "Lien invalide ou déjà utilisé.",
    },
    profile: {
      overline: "Mon compte",
      title: "Mon profil",
      infoTitle: "Informations personnelles",
      emailNote: "Si vous changez d'email, un email de confirmation sera envoyé à la nouvelle adresse (votre compte devra être reconfirmé).",
      saveBtn: "Enregistrer",
      saved: "Profil mis à jour",
      savedEmailChanged: "Profil mis à jour — confirmez votre nouvel email (lien envoyé)",
      passwordTitle: "Mot de passe",
      currentPassword: "Mot de passe actuel",
      passwordNote: "Un email de confirmation vous sera envoyé après le changement.",
      passwordBtn: "Changer le mot de passe",
      passwordChanged: "Mot de passe modifié",
      dangerTitle: "Zone de danger",
      dangerSub: "La suppression de votre compte est définitive : votre accès à la formation et votre progression seront effacés. Cette action est irréversible.",
      deletePasswordLabel: "Confirmez avec votre mot de passe",
      deleteBtn: "Supprimer définitivement mon compte",
      deleteConfirm1: "Supprimer définitivement votre compte ? Votre accès et votre progression seront effacés.",
      deleteConfirm2: "Dernière confirmation : cette action est IRRÉVERSIBLE. Continuer ?",
      deleted: "Compte supprimé. À bientôt !",
    },
    forcePw: {
      overline: "Sécurité du compte",
      title: "Choisissez votre mot de passe",
      sub: "Première connexion : pour sécuriser votre accès administrateur, remplacez le mot de passe temporaire par un mot de passe personnel.",
      submit: "Enregistrer et continuer",
      success: "Mot de passe enregistré — bienvenue !",
    },
    admin: {
      title: "Administration",
      tabMembers: "Membres", tabContent: "Contenu", tabTestimonials: "Témoignages", tabOrders: "Ventes",
      statsUsers: "Membres", statsAccess: "Accès actifs", statsOrders: "Ventes", statsRevenue: "Revenus",
      members: {
        colName: "Membre", colDate: "Inscrit le", colAccess: "Accès", colActions: "Actions",
        grant: "Donner l'accès", revoke: "Retirer l'accès", accessYes: "Oui", accessNo: "Non",
        createTitle: "Créer un compte client",
        createSub: "Pour un paiement hors PayPal : créez le compte avec un mot de passe temporaire, l'accès est activé immédiatement.",
        name: "Nom complet", email: "Email", password: "Mot de passe temporaire",
        createBtn: "Créer + donner l'accès",
        pregrantTitle: "Pré-activer un email",
        pregrantSub: "La personne créera son compte elle-même : l'accès sera activé automatiquement à son inscription.",
        pregrantBtn: "Pré-activer",
        pendingTitle: "Emails pré-activés (en attente d'inscription)",
        created: "Compte créé, accès activé",
        pregranted: "Email pré-activé",
        granted: "Accès activé", revoked: "Accès retiré",
      },
      content: {
        lesson: "Vidéo", uploadVideo: "Uploader la vidéo", uploading: "Envoi en cours…",
        noVideo: "Aucune vidéo", uploaded: "Fichier uploadé",
        pdfSection: "Fiches PDF — Module 4", uploadPdf: "Uploader un PDF", deletePdf: "Supprimer",
      },
      testi: {
        addTitle: "Ajouter un témoignage",
        name: "Nom du client", role: "Précision (optionnel)", text: "Témoignage",
        addBtn: "Publier", added: "Témoignage publié", deleted: "Témoignage supprimé",
        empty: "Aucun témoignage pour l'instant.",
      },
      orders: { colDate: "Date", colCustomer: "Client", colAmount: "Montant", colMethod: "Moyen", colStatus: "Statut", paid: "Payée", demo: "Démo", empty: "Aucune vente pour l'instant." },
      common: { confirm: "Confirmer ?" },
    },
    common: { loading: "Chargement…", error: "Une erreur est survenue.", back: "Retour" },
  },
  en: {
    brand: "M.SAH",
    nav: { home: "Home", formation: "The Course", testimonials: "Testimonials", login: "Sign in", member: "Member area", admin: "Admin", profile: "Profile", logout: "Log out" },
    home: {
      overline: "Public speaking & personal development",
      line1: "SPEAK UP.",
      line2: "BE HEARD.",
      line3: "own the room.",
      sub: "I'm M.SAH. Every day I help thousands of people speak in public with confidence — and I've condensed my method into one complete course.",
      cta: "Discover the course",
      cta2: "Who am I?",
      scroll: "Scroll",
      stat1: "TikTok followers",
      stat2: "Facebook followers",
      statFollow: "Follow",
      about: {
        overline: "Who am I?",
        title: "M.SAH,",
        titleSerif: "a speaker first.",
        p1: "Content creator in public speaking and personal development, I've built a community of over 200,000 people on TikTok and Facebook around one simple conviction: anyone can learn to speak well in public.",
        p2: "My mission: give you the concrete techniques — mental, vocal, physical — to turn stress into presence, and your ideas into impact.",
        social: "Find me on",
      },
      mission: {
        overline: "My mission",
        title: "Three convictions.",
        chapters: [
          { num: "01", title: "Speaking is learned", text: "Nobody is born a speaker. Confidence, voice, structure: everything can be trained with the right method and guided practice." },
          { num: "02", title: "Practice before theory", text: "Every video gives you immediately applicable exercises — in front of your mirror, your loved ones, then your audience." },
          { num: "03", title: "Your voice matters", text: "Whether you speak to 5 or 500 people, your message deserves to be heard. I help you carry it." },
        ],
      },
      formationTeaser: {
        overline: "The course",
        title: "High-Performance Public Speaking",
        sub: "4 modules · 16 videos · PDF exercise sheets",
        cta: "See the program",
      },
      testimonialTeaser: {
        overline: "Testimonials",
        title: "Testimonials coming soon.",
        cta: "See the testimonials page",
      },
    },
    marquee: ["PUBLIC SPEAKING", "CONFIDENCE", "VOICE", "PRESENCE", "IMPACT", "CHARISMA"],
    footer: {
      cta1: "Ready to",
      cta2: "speak up?",
      button: "Access the course",
      tagline: "Public speaking & personal development.",
      rights: "© 2026 M.SAH. All rights reserved.",
      contact: "Contact me on WhatsApp",
    },
    formation: {
      overline: "The complete course",
      hook: "The complete method to speak in public with confidence, clarity and impact — even if you're starting from scratch.",
      program: "The program",
      modules: "modules",
      videos: "videos",
      module: "Module",
      buy: "Order the course",
      owned: "Access my course",
      loginToBuy: "Create your account or sign in to order",
      accessNote: "Lifetime access — activated immediately after confirmation.",
      inc1: "Streaming videos, lifetime access",
      inc2: "Downloadable PDF exercise sheets",
      inc3: "Video-by-video progress tracking",
      inc4: "Access activated as soon as your payment is confirmed",
      orderTitle: "Order the course",
      orderNote: "Online PayPal payment is coming very soon. Meanwhile, order directly via WhatsApp: I'll unlock your access immediately after payment confirmation (Western Union, MoneyGram, Ria or other).",
      orderBtn: "Order via WhatsApp",
      whatsappMsg: "Hello M.SAH, I'd like to buy the 'Public Speaking' course (109€).",
      secure: "Flexible payment · Lifetime access · Direct WhatsApp support",
    },
    member: {
      title: "Member area",
      hello: "Hello",
      progress: "progress",
      viewedSuffix: "viewed",
      module: "Module",
      selectLesson: "Select a video to start.",
      noVideo: "This video will be available very soon.",
      pdfTitle: "Practical exercise sheets (PDF)",
      pdfSub: "Download your sheets and practice between videos.",
      download: "Download",
      downloadSheet: "Download the sheet",
      pdfCardSub: "Protected sheet — downloads are reserved for approved members.",
      noSheet: "This sheet will be available very soon.",
      noPdf: "PDF sheets will be added very soon.",
      protected: "Protected videos — streaming only.",
      buyFirst: "You don't have access to the course yet.",
      buyCta: "See the course",
    },
    testimonials: {
      overline: "Testimonials",
      title: "They spoke up.",
      empty: "The first testimonials are coming very soon.",
      emptySub: "Taking the course? Your review could appear here.",
      cta: "Discover the course",
    },
    auth: {
      loginTitle: "Welcome back.", registerTitle: "Create your account.",
      loginSub: "Pick up your course right where you left it.",
      registerSub: "One account, your course for life.",
      name: "Full name", email: "Email address", password: "Password",
      loginBtn: "Sign in", registerBtn: "Create my account",
      toRegister: "No account yet? Create one",
      toLogin: "Already a member? Sign in",
      loading: "One moment…",
      showPassword: "Show password",
      hidePassword: "Hide password",
      forgotLink: "Forgot password?",
      forgotTitle: "Forgot password.",
      forgotSub: "Enter your email: you'll receive a link to choose a new password.",
      forgotBtn: "Send the link",
      forgotSent: "If an account exists with this email, a reset link has just been sent. Check your inbox (and spam).",
      resetTitle: "New password",
      resetSub: "Choose your new password (6 characters minimum).",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      resetBtn: "Save password",
      resetMismatch: "The two passwords don't match.",
      resetInvalid: "Invalid link. Please request a new reset.",
      resetSuccessTitle: "Password updated.",
      resetSuccessSub: "You can now sign in with your new password.",
      registeredNotice: "Account created! A confirmation email has just been sent — click the link to activate your account.",
    },
    verify: {
      overline: "Email confirmation",
      wallTitle: "Confirm your email",
      wallSub: "Your account is created but not activated yet. Click the link sent by email (valid 24h) to access your content.",
      wallResend: "Resend confirmation email",
      wallResent: "Email resent! Check your inbox (and spam).",
      wallSpam: "Remember to check your spam folder. The link expires after 24h — a new one is generated with each resend.",
      successTitle: "Email confirmed!",
      successSub: "Your account is now active. You can access all your content.",
      goMember: "Go to my space",
      errorTitle: "Invalid link",
      errorSub: "The link may have expired (24h). Sign in to automatically receive a new link.",
      invalid: "Invalid or already used link.",
    },
    profile: {
      overline: "My account",
      title: "My profile",
      infoTitle: "Personal information",
      emailNote: "If you change your email, a confirmation email will be sent to the new address (your account will need reconfirmation).",
      saveBtn: "Save",
      saved: "Profile updated",
      savedEmailChanged: "Profile updated — please confirm your new email (link sent)",
      passwordTitle: "Password",
      currentPassword: "Current password",
      passwordNote: "A confirmation email will be sent after the change.",
      passwordBtn: "Change password",
      passwordChanged: "Password updated",
      dangerTitle: "Danger zone",
      dangerSub: "Deleting your account is permanent: your course access and progress will be erased. This action is irreversible.",
      deletePasswordLabel: "Confirm with your password",
      deleteBtn: "Permanently delete my account",
      deleteConfirm1: "Permanently delete your account? Your access and progress will be erased.",
      deleteConfirm2: "Final confirmation: this action is IRREVERSIBLE. Continue?",
      deleted: "Account deleted. See you soon!",
    },
    forcePw: {
      overline: "Account security",
      title: "Choose your password",
      sub: "First sign-in: to secure your administrator access, replace the temporary password with a personal one.",
      submit: "Save and continue",
      success: "Password saved — welcome!",
    },
    admin: {
      title: "Administration",
      tabMembers: "Members", tabContent: "Content", tabTestimonials: "Testimonials", tabOrders: "Sales",
      statsUsers: "Members", statsAccess: "Active access", statsOrders: "Sales", statsRevenue: "Revenue",
      members: {
        colName: "Member", colDate: "Joined", colAccess: "Access", colActions: "Actions",
        grant: "Grant access", revoke: "Revoke access", accessYes: "Yes", accessNo: "No",
        createTitle: "Create a customer account",
        createSub: "For off-PayPal payments: create the account with a temporary password, access is activated immediately.",
        name: "Full name", email: "Email", password: "Temporary password",
        createBtn: "Create + grant access",
        pregrantTitle: "Pre-activate an email",
        pregrantSub: "The person will create their own account: access activates automatically at signup.",
        pregrantBtn: "Pre-activate",
        pendingTitle: "Pre-activated emails (waiting for signup)",
        created: "Account created, access granted",
        pregranted: "Email pre-activated",
        granted: "Access granted", revoked: "Access revoked",
      },
      content: {
        lesson: "Video", uploadVideo: "Upload video", uploading: "Uploading…",
        noVideo: "No video", uploaded: "File uploaded",
        pdfSection: "PDF sheets — Module 4", uploadPdf: "Upload a PDF", deletePdf: "Delete",
      },
      testi: {
        addTitle: "Add a testimonial",
        name: "Customer name", role: "Detail (optional)", text: "Testimonial",
        addBtn: "Publish", added: "Testimonial published", deleted: "Testimonial deleted",
        empty: "No testimonials yet.",
      },
      orders: { colDate: "Date", colCustomer: "Customer", colAmount: "Amount", colMethod: "Method", colStatus: "Status", paid: "Paid", demo: "Demo", empty: "No sales yet." },
      common: { confirm: "Confirm?" },
    },
    common: { loading: "Loading…", error: "Something went wrong.", back: "Back" },
  },
};
